import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { type NavigateFunction } from 'react-router-dom';
import {
  TaxCertificationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO,
} from '../../services/wealthlane-customer-services';

const usePostW8Form = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  navigate: NavigateFunction,
  isFormFilled?: boolean | null
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TaxCertificationService.postApiCustomerApiAppTaxCertificationTaxCertificationFormW8(payload)
      );
    },
    {
      onSuccess: (
        response: // eslint-disable-next-line camelcase
          | Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO
          | undefined
      ) => {
        if (response != null) {
          queryClient.invalidateQueries('getSignUpInformation');
          // navigate('/profile', { state: { w8FormSubmitted: true, loading: true } });
          // isFormFilled ? navigate(-1) : navigate('/overview');
          //NOTE: WHEN W8 FORM IS NAVIGATED FROM W9 FORM THEN AFTER SUBMITTING W8 FORM, IT IS NAVIGATED BACK TO W9 FORM INSTEAD OF PROFILE
          isFormFilled ? navigate('/profile') : navigate('/overview');

        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostW8Form;
